import { useCallback } from "react";
import { usePaneStore } from "../state/store-context";
import { usePreferences } from "@/hooks/usePreferences";

export function useBboxToggles() {
  const showBboxOverlays = usePaneStore((s) => s.showBboxOverlays);
  const showBboxLegend = usePaneStore((s) => s.showBboxLegend);
  const setBboxOverlaysVisible = usePaneStore((s) => s.setBboxOverlaysVisible);
  const setBboxLegendVisible = usePaneStore((s) => s.setBboxLegendVisible);
  const { updatePreference } = usePreferences();

  const toggleBboxOverlays = useCallback(() => {
    const next = !showBboxOverlays;
    setBboxOverlaysVisible(next);
    updatePreference("showBboxOverlays", next);
  }, [showBboxOverlays, setBboxOverlaysVisible, updatePreference]);

  const toggleBboxLegend = useCallback(() => {
    const next = !showBboxLegend;
    setBboxLegendVisible(next);
    updatePreference("showBboxLegend", next);
  }, [showBboxLegend, setBboxLegendVisible, updatePreference]);

  return {
    showBboxOverlays,
    showBboxLegend,
    toggleBboxOverlays,
    toggleBboxLegend,
  };
}
